const PageTransactionFilter = () => import('./PageTransactionFilter');

export default {
  path: 'transactions-filter',
  name: 'transactions-filter',
  component: PageTransactionFilter,
  props: route => ({ queryParameters: route.query }),
  meta: {
    title: 'Histórico de pedidos',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/transation-filter/routes.js